<template>
  <div class="row">
    <button class="asd-btn-confirm asd-btn-adjected"
            v-help.mouse="`Nahrát soubor`"
            :disabled="disabled"
            @click="uploadAttachment()"
    >
      <i class="fas fa-file-upload"></i>
    </button>
    <input
      id="attachment"
      type="file"
      class="asd-input custom-input"
      placeholder="Vyberte soubor který chcete nahrát"
      @change="prepareFile"
    />
  </div>
</template>

<script>
import { head, size } from 'lodash'

export default {
    name: 'NewAttachment',
    props: {
        evidence: {
            type: String,
        },
        id: {
            type: String,
        },
    },
    data: function() {
        return {
            data: {
                name: 'Vyberte soubor',
            },
            base64: '',
        }
    },
    computed: {
        disabled() {
            return size(this.base64) === 0
        },
    },
    methods: {
        prepareFile(event) {
            const fileInfo = head(event.target.files)
            const reader = new FileReader()
            reader.onload = event => {
                this.base64 = event.target.result
            }
            reader.readAsDataURL(head(event.target.files))
            this.data = {
                target: this.evidence,
                target_id: this.id,
                name: fileInfo.name,
                contentType: fileInfo.type,
            }
        },
        async uploadAttachment() {
            this.data.data = this.base64.split(',')[1]
            await this.$store.dispatch('createAttachment', this.data)
            this.base64 = ''
        },
    },
}
</script>

<style lang="scss" scoped>
.custom-input {
    padding: 3px;
    margin: 0;
    max-width: calc(100vw - 300px);
}
.row {
    display: flex;
    margin: 15px auto 0 0px;
}
</style>
